import React from 'react'

import { getGPUHandbook } from 'services/apiRequests'

import { useDispatch } from 'react-redux'
import { setDirectoryItems, setId, setVersionId } from 'store/directorySlice'

const useGetGPU = (requestData: boolean) => {
  const dispatch = useDispatch()

  const tryToGetGPU = async () => {
    await getGPUHandbook().then((res) => {
      dispatch(setId(res.data.id))
      dispatch(setVersionId(res.data.id))
      dispatch(
        setDirectoryItems(
          res.data.units.map((unit) => {
            return {
              ...unit,
              modified: false,
            }
          }),
        ),
      )
    })
  }

  React.useEffect(() => {
    tryToGetGPU().then()
  }, [requestData])

  return
}

export default useGetGPU
